module.exports = __webpack_public_path__ + "static/media/ArrowDown.78d9bfa8.svg";